import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { DropzoneDialog } from "material-ui-dropzone";
import {
  addFindingAttachments,
  deleteFindingAttachment,
} from "../../../redux/actions/Findings";
import moment from "moment-timezone";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  Button as MuiButton,
} from "@material-ui/core";

class FindingAttachmentsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploaderOpen: false,
      isConfirmationDialogOpen: false,
      showConfirmAttachmentDelete: null,
      attachmentDeletesInProgress: [],
    };
  }

  closeUploader() {
    this.setState({
      uploaderOpen: false,
    });
  }

  uploadFiles(files) {
    this.setState({
      uploaderOpen: false,
    });
    this.props.dispatchAddFindingAttachments({
      orgId: this.props.orgId,
      findingId: this.props.findingId,
      files: files,
    });
    this.props.reload(true);
  }

  openUploader() {
    this.setState({
      uploaderOpen: true,
    });
  }

  toggleConfirmationDialog() {
    this.setState({
      isConfirmationDialogOpen: !this.state.isConfirmationDialogOpen,
    });
  }

  handleConfirm() {
    this.setState({
      uploaderOpen: true,
      isConfirmationDialogOpen: false,
    });
  }

  startAttachmentDelete(id) {
    this.setState({
      showConfirmAttachmentDelete: id,
    });
  }

  confirmPendingAttachmentDelete() {
    const attachmentId = this.state.showConfirmAttachmentDelete;
    const newDeletesInProgress = Array.from(
      this.state.attachmentDeletesInProgress
    );
    newDeletesInProgress.push(attachmentId);
    this.setState({
      attachmentDeletesInProgress: newDeletesInProgress,
      showConfirmAttachmentDelete: null,
    });
    this.props.dispatchDeleteFindingAttachment({
      orgId: this.props.orgId,
      findingId: this.props.findingId,
      attachmentId: attachmentId,
    });
    this.props.reload(true);
  }

  cancelPendingAttachmentDelete() {
    this.setState({
      showConfirmAttachmentDelete: null,
    });
  }

  canCurrentUserDeleteAttachment(attachment) {
    if (this.props.currentUserId === attachment.uploaded_by) {
      // if this user uploaded the attachment, they can delete it:
      return true;
    }
    const currentUser = this.props.users[this.props.currentUserId];
    const currentUserRolesInOrg =
      currentUser && currentUser.orgRoles
        ? currentUser.orgRoles
            .filter((role) => role.orgId === this.props.orgId)
            .map((role) => role.roleId)
        : [];
    // if this user is an admin or manager for this org, they can delete the attachment:
    return (
      currentUserRolesInOrg.includes(10) || currentUserRolesInOrg.includes(20)
    );
    // ofc, this is enforced by FEA
  }

  // TODO(cdzombak): error showing

  renderAttachment(a) {
    const date_str = moment
      .utc(a.uploaded_at)
      .tz(moment.tz.guess(true))
      .format("lll z");
    const uploader = this.props.users[a.uploaded_by];
    const uploader_el = uploader ? (
      <span>
        by{" "}
        <strong>
          {uploader.first_name} {uploader.last_name}
        </strong>
      </span>
    ) : null;
    return (
      <div className="attachment" key={a.id}>
        <a href={a.signed_get_url} style={{ wordBreak: "break-all" }}>
          <span className="icon" style={{ marginRight: 4 }}>
            <i className="fas fa-paperclip" />
          </span>
          {a.filename}
        </a>
        <br />
        {a.id === this.state.showConfirmAttachmentDelete ? (
          <div>
            <div
              style={{
                float: "right",
                marginLeft: 12,
                marginTop: 4,
                marginBottom: -4,
              }}
            >
              <Button
                className="btn-sm"
                bsStyle="danger"
                onClick={() => this.confirmPendingAttachmentDelete()}
              >
                Yes
              </Button>
              <Button
                className="btn-sm"
                bsStyle="primary"
                onClick={() => this.cancelPendingAttachmentDelete()}
                style={{ marginLeft: 6 }}
              >
                No
              </Button>
            </div>
            <strong>Permanently delete this attachment?</strong>
          </div>
        ) : (
          <div>
            {this.canCurrentUserDeleteAttachment(a) ? (
              <div
                style={{
                  float: "right",
                  marginLeft: 12,
                  marginTop: 4,
                  marginBottom: -4,
                }}
              >
                {this.state.attachmentDeletesInProgress.includes(a.id) ? (
                  <CircularProgress size={26} color="secondary" />
                ) : (
                  <Button
                    className="btn-sm"
                    bsStyle="danger"
                    onClick={() => this.startAttachmentDelete(a.id)}
                  >
                    <i className="fas fa-trash" />
                  </Button>
                )}
              </div>
            ) : null}
            Added {date_str} {uploader_el}
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="infoTitle">
          Attachments
          <MuiButton
            bsStyle="primary"
            style={{ float: "right" }}
            onClick={this.toggleConfirmationDialog.bind(this)}
            color={"primary"}
            variant={"contained"}
          >
            Upload
          </MuiButton>
        </div>
        {this.props.attachments.length ? (
          this.props.attachments.map(this.renderAttachment.bind(this))
        ) : (
          <p>No attachments.</p>
        )}
        <Dialog open={this.state.isConfirmationDialogOpen}>
          <DialogTitle>Acknowledgement of Sensitive Material</DialogTitle>
          <DialogContent>
            <p>
              Please refrain from uploading any sensitive, confidential or
              privileged assets to your finding.
            </p>
          </DialogContent>
          <DialogActions>
            <MuiButton
              onClick={this.toggleConfirmationDialog.bind(this)}
              color={"primary"}
              variant={"text"}
            >
              Cancel
            </MuiButton>
            <MuiButton
              onClick={this.handleConfirm.bind(this)}
              color={"primary"}
              variant={"contained"}
            >
              Acknowledge
            </MuiButton>
          </DialogActions>
        </Dialog>
        <DropzoneDialog
          open={this.state.uploaderOpen}
          onSave={this.uploadFiles.bind(this)}
          onClose={this.closeUploader.bind(this)}
          dropzoneText="Drag files here, or click to open a file browser."
          dialogTitle="Attach Files"
          filesLimit={5}
          maxFileSize={104857600}
          submitButtonText="Upload"
          showPreviews={true}
          showFileNames={true}
          showFileNamesInPreview={true}
          showAlerts={["error"]}
        />
      </div>
    );
  }
}

FindingAttachmentsView.propTypes = {
  dispatchAddFindingAttachments: PropTypes.func.isRequired,
  dispatchDeleteFindingAttachment: PropTypes.func.isRequired,
  attachments: PropTypes.array.isRequired,
  currentUserId: PropTypes.string.isRequired,
  findingId: PropTypes.string.isRequired,
  orgId: PropTypes.string.isRequired,
  users: PropTypes.object.isRequired,
};

FindingAttachmentsView.defaultProps = {
  attachments: [],
  currentUserId: "",
  findingId: "",
  orgId: "",
  users: {},
};

const mapStateToProps = (state) => ({
  currentUserId: state.session.settings.user.id,
  users: state.users.byId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchAddFindingAttachments: ({ orgId, findingId, files }) => {
    dispatch(addFindingAttachments({ orgId, findingId, files }));
  },
  dispatchDeleteFindingAttachment: ({ orgId, findingId, attachmentId }) => {
    dispatch(deleteFindingAttachment({ orgId, findingId, attachmentId }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FindingAttachmentsView);
